import React, { useEffect } from "react"
import { Link } from "react-router-dom";
import { getOwner, isAccountLimited, openAnnouncements, openBrowserPhone, setUnseenNotificationsCount, useCanUpgradePlan, useEnvironment, useGlobal, useHub, useScreen, useUnseenMissedCallsCount } from "../../../core/Global";
import { UserTypes } from "../../../core/Enums";
import Icon from "../../base/Icon";
import HeaderNavbar from "./HeaderNavbar";
import UserMenu from "./UserMenu";
import UserWallet from "./UserWallet";
import FlexRow from "../../base/FlexRow";
import HeaderEnvironment from "./HeaderEnvironment";
import MobileHeader from "./MobileHeader";
import UserClaimedExts from "./UserClaimedExts";
import PlanNoticePill from "../../plans/PlanNoticePill";
import HeaderConnectedAccounts from "./HeaderConnectedAccounts";
import { usePWAStatus } from "../../../hooks/usePWAStatus";
import { isNativeApp } from "../../../NativeAppBrdige";
import { trackGrowth } from "../../growth/GrowthSignal";

function Header() {

  const hub = useHub();
  const [globalState] = useGlobal();
  const { isStandalone } = usePWAStatus();
  const screen = useScreen()
  const env = useEnvironment();
  const unseenMissed = useUnseenMissedCallsCount();
  const canUpgradePlan = useCanUpgradePlan();

  useEffect(() => {
    if (globalState.user?.isCustomer) {
      setTimeout(() => {
        window.KTMenuCreate();
      }, 200);
    }
  }, [globalState.user])
  return (
    <div id="kt_header" className="header align-items-stretch">

      <MobileHeader />

      <div className="container-fluid d-none d-lg-flex align-items-stretch justify-content-between">

        <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
          <HeaderNavbar />
          <div className="d-flex align-items-center flex-shrink-0 d-none d-md-flex">



            {
              (globalState.user?.needsSubscribe ||
                (isAccountLimited() && (globalState.user?.isCustomer || globalState.user?.userType == UserTypes.Admin))) &&
              <div className="me-10">
                <Link to="/system/finance/subscription" className="btn btn-danger btn-sm">Subscribe Now</Link>
              </div>
            }

            {
              /* A downgrade or a pause on its way, or a paused account -- on every screen until it
                 happens, with the way to cancel it or come back. Not for technicians. */
              (globalState.user?.isCustomer || globalState.user?.userType === UserTypes.Admin) &&
              <div className="me-6">
                <PlanNoticePill />
              </div>
            }

            {
              /* The new plans never reach "Subscribe Now": a plan that is not renewed drops to
                 Free rather than locking the account, so there is nothing to restore -- only a
                 better plan to move to. Not red for the same reason: nothing is broken. */
              canUpgradePlan && !globalState.user?.needsSubscribe &&
              (globalState.user?.isCustomer || globalState.user?.userType == UserTypes.Admin) &&
              <div className="me-10">
                <Link to="/system/finance/subscription" className="btn btn-primary btn-sm"
                  onClick={() => trackGrowth("upgrade_clicked", "plan", "header")}>
                  <Icon icon="arrow-up-right-dots" type="solid" className="me-2" />
                  Upgrade Plan
                </Link>
              </div>
            }

            {
              false && <UserClaimedExts />
            }

            {/* {
              owner?.id === "66865dea0620110d4f30dc74" && <UserClaimedExts />
            } */}



            {
              globalState.user?.isSystemAdmin && <HeaderEnvironment />
            }

            {
              globalState.user?.connectedAccounts && globalState.user.connectedAccounts.length > 0 &&
              <HeaderConnectedAccounts />
            }

            {(globalState.user?.isCustomer || globalState.user?.isSystemAdmin) && <UserWallet />}



            <FlexRow className="d-flex align-items-center">

              {
                !isNativeApp() && !screen.isMobile &&
                !globalState.user?.isTech &&
                !isStandalone &&
                <div className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px position-relative" title={unseenMissed > 0 ? `${unseenMissed} missed call${unseenMissed > 1 ? "s" : ""}` : "Phone"}
                  onClick={e => {
                    e.preventDefault()
                    openBrowserPhone()
                  }}>
                  <Icon icon="phone" type="solid" className="text-gray-600" size={16} />
                  {
                    unseenMissed > 0 &&
                    <span className="position-absolute translate-middle badge badge-circle badge-danger" style={{
                      top: "20%",
                      left: "70%",
                      width: 18,
                      height: 18,
                      overflow: "hidden",
                      lineHeight: 18,
                      fontSize: 11
                    }}>
                      {unseenMissed > 9 ? "9+" : unseenMissed}
                    </span>
                  }
                </div>
              }



              <div className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px position-relative" title="Announcements"
                onClick={e => {
                  e.preventDefault()
                  openAnnouncements()
                }}>
                <Icon icon="bullhorn" type="solid" className="text-gray-600" size={16} />
                {
                  globalState.announcements && globalState.announcements.length > 0 &&
                  <span className="position-absolute translate-middle badge badge-circle badge-info" style={{
                    top: "20%",
                    left: "70%",
                    width: 18,
                    height: 18,
                    overflow: "hidden",
                    lineHeight: 18,
                    fontSize: 11
                  }}>
                    {globalState.announcements.length > 10 ? "9+" : globalState.announcements.length}
                  </span>
                }
              </div>

              <div className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px position-relative" id="kt_activities_toggle"
                onClick={e => {
                  hub.Put("/accounts/notifications/seenall", {}, res => {
                    if (res.success) {
                      setUnseenNotificationsCount(0);
                    }
                  });
                }}>
                <Icon icon="bell" type="solid" className="text-gray-600" size={16} />
                {
                  globalState.unseenNotificationsCount && globalState.unseenNotificationsCount > 0 ?
                    <span className="position-absolute translate-middle badge badge-circle badge-primary" style={{
                      top: "15%",
                      left: "70%"
                    }}>
                      {globalState.unseenNotificationsCount > 10 ? "9+" : globalState.unseenNotificationsCount}
                    </span>
                    :
                    <>
                      {
                        globalState.unreadNotificationsCount && globalState.unreadNotificationsCount > 0 ?
                          <span className="bullet bullet-dot bg-primary h-6px w-6px position-absolute translate-middle top-25 start-75"></span>
                          : <></>
                      }
                    </>
                }
              </div>

            </FlexRow>

            <UserMenu />

          </div>

        </div>
      </div>


    </div>
  );
}

export default Header;
